import { gql } from 'apollo-boost'

const SCRAPING_SESSION_TAG_SCORES = gql`
  query scrapingSessionTagScores($sessionId: ID!) {
    scrapingSessionTagScores(sessionId: $sessionId) {
      type
      name
      count
      averageValidationScore
      averageSimilarity
    }
  }
`

export default SCRAPING_SESSION_TAG_SCORES
